function buildUrl(url:string, baseUrl:string): string {
    if(url.startsWith('http')){
        return url
    } else {
        const baseUrlWithSlash = baseUrl.endsWith('/') ? baseUrl : baseUrl + '/'
        const urlWithoutSlash = url.startsWith('/') ? url.slice(1) : url
        return baseUrlWithSlash + urlWithoutSlash
    }
}

export { buildUrl }
